export const CampaignStatus = {
    Draft: {
        label: 'Draft',
        key: 'Draft',
        icon: 'StatusDotOutline',
        color: '#989898',
        apiStatus: ['NEW REQUEST', 'PLANNING']
    },
    Pending: {
        label: 'Pending',
        key: 'Pending',
        icon: 'StatusDot',
        color: '#fa9b2f',
        size: 15,
        apiStatus: ['NEGOTIATING', 'REQUEST SENT', 'SENT']
    },
    Ready: {
        label: 'Ready',
        key: 'Ready',
        icon: 'StatusDotOutline',
        color: '#46862d',
        apiStatus: ['RUNNING']
    },
    Running: {
        label: 'Running',
        key: 'Running',
        icon: 'StatusDot',
        color: '#46862d',
        size: 15,
        apiStatus: ['RUNNING']
    },
    Completed: {
        label: 'Completed',
        key: 'Completed',
        icon: 'StatusDot',
        color: '#989898',
        size: 15,
        apiStatus: ['CANCELLED', 'ENDED', 'FINISHED']
    },
    Canceled: {
        label: 'Canceled',
        key: 'Canceled',
        icon: 'StatusDot',
        color: '#989898',
        size: 15,
        apiStatus: ['DECLINED']
    }
}
